import type { BUCKETS } from './types';

import type { IJobApplicationStore } from './index';

interface EventCaptureInfo {
  advertiserId: string;
  currentPage: number;
  userId: number | null;
}

export interface DetailViewEventCaptureInfo extends EventCaptureInfo {
  hasRR: boolean;
  isSmallDevice: boolean;
  jobId: number | null;
  listingId: number;
  positionId: number;
  seekAdvertiserId: string;
}

export interface CertsyOrListEventCaptureInfo
  extends DetailViewEventCaptureInfo {
  bucket: BUCKETS | '';
  searchText: string;
  seekAdvertiserId: string;
}

export const getCertsyOrListEventCaptureInfo = (
  jobApplicationStore: IJobApplicationStore,
): CertsyOrListEventCaptureInfo => ({
  advertiserId: jobApplicationStore.rootStore.advertiserId,
  bucket: jobApplicationStore.bucket,
  currentPage: jobApplicationStore.currentPage,
  hasRR: jobApplicationStore.jobStore.questionnaire.hasQuestion,
  isSmallDevice: jobApplicationStore.rootStore.isMobile,
  jobId: jobApplicationStore.jobStore.job.jobInformation.jobId, // Job ID used within SEEK Jobs
  listingId: jobApplicationStore.jobStore.job.jobInformation.listingId, // Job ID used to tie SEEK Jobs and Advertiser IDs together
  positionId: jobApplicationStore.jobStore.job.positionId, // Job ID used within Advertiser
  searchText: jobApplicationStore.searchText,
  seekAdvertiserId: jobApplicationStore.rootStore.seekAdvertiserId,
  userId: jobApplicationStore.userStore.user.userId,
});
